import { CoreoProjectFeatures } from "../../types";

/** Features that change the synced config itself (surveys lose their styling without dataDrivenStyling). */
const CONFIG_DEPENDENT_FEATURES: string[] = ['dataDrivenStyling'];

/**
 * What a sync check's features mean for the stored project: nothing, a patch of the
 * stored flags, or a config sync because the synced config depends on the change.
 */
export type ProjectFeaturesChange = 'none' | 'patch' | 'config';

export const compareProjectFeatures = (
  local: Partial<CoreoProjectFeatures> | null | undefined,
  remote: Partial<CoreoProjectFeatures> | null | undefined
): ProjectFeaturesChange => {
  if (!remote) {
    return 'none';
  }
  const keys = new Set([...Object.keys(local ?? {}), ...Object.keys(remote)]);
  let changed = false;
  for (const key of keys) {
    if (!!local?.[key] === !!remote[key]) {
      continue;
    }
    if (CONFIG_DEPENDENT_FEATURES.includes(key)) {
      return 'config';
    }
    changed = true;
  }
  return changed ? 'patch' : 'none';
};
